export * from './lib/select-customer-dialog.module';

export * from './lib/select-customer-dialog.component';
